import { class_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import React from "react";
import * as react from "react";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { InputAdornment, TextField } from "@mui/material";
import { singleton, empty, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { value as value_27, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Colors_LightBlue } from "../Design.js";
import Search from "@mui/icons-material/Search";

export class Components {
    constructor() {
    }
}

export function Components_$reflection() {
    return class_type("Kundeweb.Components", undefined, Components);
}

export function Components_Searchbar_25F45B5E(components_Searchbar_25F45B5EInputProps) {
    const sx = components_Searchbar_25F45B5EInputProps.sx;
    const props = components_Searchbar_25F45B5EInputProps.props;
    const fullWidth = components_Searchbar_25F45B5EInputProps.fullWidth;
    const onChange = components_Searchbar_25F45B5EInputProps.onChange;
    const placeholder = components_Searchbar_25F45B5EInputProps.placeholder;
    return MuiHelpers_createElement(TextField, toList(delay(() => {
        let matchValue, ps;
        return append((matchValue = props, (matchValue != null) ? ((ps = matchValue, Object.entries(ps))) : (empty())), delay(() => append(singleton(["fullWidth", defaultArg(fullWidth, true)]), delay(() => append(singleton(["sx", createObj(toList(delay(() => {
            if (sx != null) {
                const styles = value_27(sx);
                return Object.entries(styles);
            }
            else {
                return empty();
            }
        })))]), delay(() => append(singleton(["variant", "standard"]), delay(() => append(singleton(["placeholder", placeholder]), delay(() => append(singleton(["onChange", onChange]), delay(() => append(singleton(["inputProps", {
            sx: {
                padding: 0,
            },
        }]), delay(() => {
            let props_3;
            return singleton(["InputProps", {
                disableUnderline: true,
                sx: {
                    cursor: "pointer",
                    borderRadius: 4 + "px",
                    backgroundColor: Colors_LightBlue(0.2),
                    padding: ((((((10 + "px ") + 15) + "px ") + 10) + "px ") + 15) + "px",
                },
                startAdornment: MuiHelpers_createElement(InputAdornment, [["position", "start"], ["children", (props_3 = {
                    style: {
                        color: "var(--navy)",
                    },
                }, react.createElement(Search, props_3))]]),
            }]);
        }))))))))))))));
    })));
}

